import { IconAsteriskHexagon, IconStar2, IconStar4 } from "./icons";

export const defaultIcons = {
  findings: <IconStar2 width={24} height={24} />,
  hypoteses: <IconStar4 width={24} height={24} />,
  endpoints: <IconAsteriskHexagon width={24} height={24} />,
};
